import { Box } from '@chakra-ui/react';

const WideQuestionTemplate = ({ children }) => {

  return (
    <>
    <Box
      sx={{
        width: '100%',
        display: 'flex',
        justifyContent: 'center',
      }}
    >
      <Box sx={{ width: '100%', maxWidth: '1200px' }}>
        {children}
      </Box>
    </Box>
      </>
  );
};

export default WideQuestionTemplate;
